<script>
  import { getContext, createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  export let src = ''
  export let alt = null
  export let title = ''
  export let url = ''
  export let id = null
  export let width = ''
  export let className = null
  export let style = null
  export let isExpandable = false
  export let target = '_self'

  const platform = getContext('platform')
  const { store } = platform
  const { modes } = platform.api.cms.editor
  const { isAboveTheFold } = platform.api.core.render

  let img

  // These are reactive statements to ensure that background image editor changes are updated in this component.
  $: source = src
  $: path = source?.split('?').shift()
  $: query = new URLSearchParams(source?.split('?').pop() || '')
  $: lazySrc = `${path}?size=md`

  $: if (query.get('aspect-ratio')) {
    const [width, height] = query.get('aspect-ratio').split(':')

    style ||= ''
    style = `aspect-ratio: ${width}/${height};` + style
  }

  $: if (img && lazySrc) {
    if ($store.appInitialised) {
      lazySrc = `${path}?size=md`
    } else {
      lazySrc = platform.api.core.captured(img, lazySrc)
    }
  }

  function handleDispatch () {
    if (!isExpandable) {
      return
    }

    dispatch('expand')
  }

  function handleLink () {
    if (!url || $store.editor.mode !== modes.VIEW) {
      return
    }

    if (url.startsWith('https')) {
      window.open(url, '_blank')
    } else {
      if (target === '_blank') {
        window.open(`${platform.router.pathname}${url}`, '_blank')
      } else {
        platform.router.push(url)
      }
    }
  }
</script>

<img
  id={id}
  class={className}
  class:cursor-pointer={url || isExpandable}
  alt={alt}
  title={title}
  style={style}
  width={width}
  src={lazySrc}
  loading={!isAboveTheFold ? 'lazy' : null}
  optimise={isAboveTheFold ? 'true' : null}
  bind:this={img}
  on:click={(event) => {
    handleLink(event)
    handleDispatch(event)
  }}
>

<noscript>
  <img
    id={id}
    class={className}
    alt={alt}
    title={title}
    style={style}
    src="{path}?size=md"
    srcset="{path}?size=xs 128w, {path}?size=sm 256w, {path}?size=md 512w, {path}?size=lg 1024w, {path}?size=xl 2048w"
    loading="lazy"
  >
</noscript>

<style>
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .ml-auto {
    margin-left: auto;
  }

  .mr-auto {
    margin-right: auto;
  }

  .cursor-pointer {
    cursor: zoom-in;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>